import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class TropicalLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Storm tracks";
		this.popupName = "Storm tracks";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
		// this.layer is the base layer for this Manager created in AbstractLayerManager->attachLayer
		// create a set of sublayers grouped under this.layer
		this.layers = {};
	}

	createSublayers() {
		// init the sublayers
		this.layers.tropTrack = L.featureGroup().addTo(this.layer);
		this.layers.tropForecast = L.featureGroup().addTo(this.layer);
		this.layers.tropForecastMarkers = L.featureGroup().addTo(this.layer);
	}

	cleanup() {
		this.layer.removeLayer(this.layers.tropTrack);
		this.layer.removeLayer(this.layers.tropForecast);
		this.layer.removeLayer(this.layers.tropForecastMarkers);
		this.layers = {};
	}

	refreshLayer() {
		this.requestTropical();
	}
	
	requestTropical() {
		this.inst.setLoadingMonitor(this.id, true);

		if(this.tasks.fetchTropical === undefined) this.tasks.fetchTropical = new Request({
			url: 'https://api.weatherusa.net/v1.2/feed/tropical',
			data: {'storm': 'active'},
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchTropical.get();
	}

	handleError(err) {
		this.inst.setLoadingMonitor(this.id, false);
		console.error(err);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		let storms = resp.body.data;
		// Clear sublayers from our groups
		for(const [id, l] of Object.entries(this.layers)) {
			l.clearLayers();
		}

		for(const [id, storm] of Object.entries(storms)) {
			var i = 0;
			var prevCoord = {};
			var prevWind = 0;
			
			for(const marker of storm.history) {
				// Fixup for Leaflet issue #1293
				if(marker.lon > 0) marker.lon = marker.lon - 360;
				if(prevCoord.lat)
				{
					var color = this.windToColor(prevWind);
					L.polyline([prevCoord, new L.LatLng(marker.lat, marker.lon)], {color: color, weight: 3, opacity: 1.0}).addTo(this.layers.tropTrack);
				}
				prevCoord = new L.LatLng(marker.lat, marker.lon);
				prevWind = marker.winds;
			}
			// Now pop off the last marker for lastMarker
			var lastMarker = storm.history.pop();
			// Fixup for Leaflet issue #1293
			if(lastMarker.lon > 0) lastMarker.lon = lastMarker.lon - 360;
			// Display past storm position markers
			for(const marker of storm.history) {
				// Fixup for Leaflet issue #1293
				if(marker.lon > 0) marker.lon = marker.lon - 360;
				var color = this.windToColor(marker.winds);
				L.circleMarker(new L.LatLng(marker.lat, marker.lon),
					{radius: 8, stroke: true, color: '#e0e0e0', weight: 1, opacity: 1.0, fill: true, fillColor: color, fillOpacity: 1.0})
					.bindPopup('<strong><em>' + marker.name + '</em></strong><br /><strong>Position time:</strong> ' + marker.date + '<br /><strong>Winds:</strong> ' + marker.winds + ' ' + ' MPH<br /><strong>Moving:</strong> ' + marker.dir + ' at ' + marker.speed + ' MPH<br /><strong>Central Pressure:</strong> ' + marker.pressure + ' mb', 
						{autoPanPadding: L.point(46, 36)})
					.addTo(this.layers.tropTrack);
			}
			
			if(lastMarker) {
				// Draw a nice TC icon
				if(lastMarker.storm_id < 90)
				{
					// silly init
					var iconClass = 'tc_td';
					var symClass = '';
					var txt = 'L';

					if(lastMarker.winds < 39)
					{
						iconClass ='tc_td';
						symClass = '';
						txt = 'L';
					}
					else if(lastMarker.winds >= 39 && lastMarker.winds <= 73)
					{
						iconClass = 'tc_ts';
						symClass = 'tc_spin';
						txt = ''; // TS
					}
					else if(lastMarker.winds >= 74 && lastMarker.winds <= 95)
					{
						iconClass = 'tc_cat1';
						symClass = 'tc_spin';
						txt = '1';
					}
					else if(lastMarker.winds >= 96 && lastMarker.winds <= 110)
					{
						iconClass = 'tc_cat2';
						symClass = 'tc_spin';
						txt = '2';
					}
					else if(lastMarker.winds >= 111 && lastMarker.winds <= 129)
					{
						iconClass = 'tc_cat3';
						symClass = 'tc_spin';
						txt = '3';
					}
					else if(lastMarker.winds >= 130 && lastMarker.winds <= 156)
					{
						iconClass = 'tc_cat4';
						symClass = 'tc_spin';
						txt = '4';
					}
					else if(lastMarker.winds > 156)
					{
						iconClass = 'tc_cat5';
						symClass = 'tc_spin';
						txt = '5';
					}

					var stormIcon = new L.DivIcon({
						iconSize: [40, 45],
						className: 'map_marker_tc ' + iconClass,
						html: '<span class="tc_sym ' + symClass + '"></span><span class="tc_symlabel">' + txt + '</span><span class="tc_name">' + lastMarker.name.substr(lastMarker.name.lastIndexOf(' ')+1) + '</span>'
					});
				}
				else
				{
					// Draw an X for the disturbance
					var stormIcon = new L.DivIcon({
						iconSize: [26, 42],
						className: 'map_marker_tc tc_inv',
						html: '<span class="tc_symlabel">&times;</span><span class="tc_name">' + lastMarker.name.substr(lastMarker.name.lastIndexOf(' ')+1) + '</span>'
					});
				}

				L.marker(new L.LatLng(lastMarker.lat, lastMarker.lon), {
					icon: stormIcon,
					title: lastMarker.name
				})
				.bindPopup('<strong><em>' + lastMarker.name + '</em></strong><br /><strong>Observation time:</strong> ' + lastMarker.date + '<br /><strong>Winds:</strong> ' + lastMarker.winds + ' ' + ' MPH<br /><strong>Moving:</strong> ' + lastMarker.dir + ' at ' + lastMarker.speed + ' MPH<br /><strong>Central Pressure:</strong> ' + lastMarker.pressure + ' mb',
					{autoPanPadding: L.point(46, 36)})
				.addTo(this.layers.tropTrack);

				if(storm.forecast)
				{
					this.loadTropForecast(storm, lastMarker);
				}
			}
		}

	//	map.maxZoom = 7;
	//	map.fitBounds(map_layers.TropTrack.getBounds());
	//	map.maxZoom = 12;

		this.inst.setLoadingMonitor(this.id, false);
		
	}	
	
	loadTropForecast(storm, init) {
		var color = '#eee';
		var prevCoord = {};
		var prevWind = 0;
	
		// Add forecast error cone
		if(storm.cone) {
			var polyPath = [];
			try {
				for(const pt of storm.cone) {
					// FIXME Fixup for Leaflet issue #1293
					if(pt[0] > 0) pt[0] = pt[0] - 360;
					polyPath.push(L.latLng(pt[1], pt[0]));
				}
				L.polygon(polyPath, {fillColor: '#eee', weight: 0, fillOpacity: 0.43}).addTo(this.layers.tropForecast);
			}
			catch(e) {}
		}
		
		for(const [id, pos] of Object.entries(storm.forecast)) {
			// Fixup for Leaflet issue #1293
			if(pos.lon > 0) pos.lon = pos.lon - 360;
			
			// Add overlay lines
			if(!prevCoord.lat)
			{
				prevCoord = {lat: init.lat, lon: init.lon};
				prevWind = init.winds;
			}

			// Add forecast track line
			color = this.windToColor(prevWind);
			L.polyline([prevCoord, L.latLng(pos.lat, pos.lon)], {color: color, weight: 3, opacity: 1.0, dashArray: '8,7'}).addTo(this.layers.tropForecast);
		
			prevCoord = L.latLng(pos.lat, pos.lon);
			prevWind = pos.winds_mph;
			
			// Add forecast points
			L.circleMarker(L.latLng(pos.lat, pos.lon),
				{radius: 9, stroke: true, color: '#eee', weight: 2, opacity: 0.9, fill: true, fillColor: '#fff', fillOpacity: 0.38})
				.bindPopup('<strong>Forecast time:</strong> ' + pos.time + '<br /><strong>Winds:</strong> ' + pos.winds_mph + ' ' + ' MPH, Gusts to ' + pos.gusts_mph + ' MPH', 
					{autoPanPadding: L.point(46, 36)})
				.addTo(this.layers.tropForecastMarkers);
		}
		
		this.layers.tropForecast.bringToBack();
	}

	handleClick(e) {
		this.inst.forwardedClickHandler(this.id, e, e.target.details);
	}

	windToColor(prevWind) {
		var color = '#abe7f1';
		if(prevWind < 39)
		{
			color = '#abe7f1';
		}
		else if(prevWind >= 39 && prevWind <= 73)
		{
			color = '#58c4e6';
		}
		else if(prevWind >= 74 && prevWind <= 95)
		{
			color = '#e8e264';
		}
		else if(prevWind >= 96 && prevWind <= 110)
		{
			color = '#f8bb44';
		}
		else if(prevWind >= 111 && prevWind <= 129)
		{
			color = '#f58954';
		}
		else if(prevWind >= 130 && prevWind <= 156)
		{
			color = '#e96d6b';
		}
		else if(prevWind > 156)
		{
			color = '#ef8fb1';
		}
		return color;
	}
}
